import React from 'react'
import {Link} from 'react-router-dom'
import Reflux from 'reflux'
import Store from '../../store/store'
import Modal from 'react-modal'
import Field from '../common/Field'
import Validator from '../common/Validator'
import List from './Table/List'
import api from '../../source/api'
import user from '../../helpers/user'
import i18 from '../../i18'
import Loading from '../common/loading'
import actions from '../../actions/actions'
import BaseComponent from '../base'
import userHelper from '../../helpers/user'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
}

Modal.setAppElement('#root')

class Company extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            modalIsOpen: false,
            isNewRecord: false,
            companies: [],
            fields: {
                name: {value: '', error: '', role: {required: true}},
                id: {value: '', error: '', role: {required: false}},
            },
            error: false,
            loading: false,
            success: '',
            filterText: ''
        }
        this.store = Store;
    }

    openModal = () => {
        this.state.isNewRecord = true
        this.state.fields.name.value = ''
        this.state.fields.name.error = ''
        this.setState({modalIsOpen: true})
    }

    closeModal = () => {
        this.state.fields.name.error = ''
        this.setState({modalIsOpen: false})
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'company', data: {}}, true).then((response) => {
            user.setUserData('balanceInfo', response.data.balanceInfo);
            user.setUserData('enabledModules', response.data.enabledModules);
            this.setState({companies: response.data.companies})

        }).catch((err) => {
            if (err.response.data === 'INVALID_HEADER_3' || err.response.data === 'INVALID_HEADER_2') {
                actions.logout()
                localStorage.removeItem('user')
            }
        })
    }

    create = () => {
        let validator = Validator.validate(this.state.fields)

        if (validator.error) {
            this.setState({
                error: validator.error,
                fields: validator.fields,
            });
            return;
        }

        this.setState({modalIsOpen: false})
        let data = {name: this.state.fields.name.value}
        api.post({url: 'company', data}, true).then((response) => {
            if (response.status === 201) {
                this.setState({companies: response.data})
            }
        })
    }

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields});
    }

    edit = (company) => {
        let fields = this.state.fields;
        fields.name.error = ''
        fields.name.value = company.name
        fields.id.value = company.id
        this.setState({
            isNewRecord: false,
            fields: fields,
            modalIsOpen: true
        })
    }

    update = () => {
        let data = {
            name: this.state.fields.name.value,
            id: this.state.fields.id.value
        };
        api.put({url: `company/${data.id}`, data}, true).then((response) => {
            this.setState({
                companies: response.data,
                modalIsOpen: false
            })
        })
    }

    delete = (id) => {
        let r = window.confirm('Biztos törölni szeretné?')
        if (r === true) {
            api.delete({url: `company/${id}`, data: {}}, true).then((response) => {
                this.setState({companies: response.data});
            })
        }
    }

    getCompanies = () => {
        let CompaniesList = []
        for (let index in this.state.companies) {
            let company = this.state.companies[index];

            if (this.state.filterText) {
                let filterText = this.state.filterText.toLowerCase();
                if (
                    company.name.toLowerCase().indexOf(filterText) === -1
                ) {
                    continue;
                }
            }

            CompaniesList.push(<List
                edit={(company) => this.edit(company)}
                delete={(id) => this.delete(id)}
                key={company.id}
                company={company}/>)
        }

        let colspan = 3
            + (userHelper.hasModule('customer') ? 1 : 0)
            + (userHelper.hasModule('bank') ? 1 : 0)
            + (userHelper.hasModule('supplier') ? 1 : 0)
            + (userHelper.hasModule('cashregister') ? 1 : 0)
            + (userHelper.hasModule('mixed') ? 1 : 0)

        return CompaniesList.length > 0 ? CompaniesList : <tr>
            <td colSpan={colspan} className='text-center'>{i18.COMPANY._noCompaniesFoud}</td>
        </tr>
    }

    onFilterChange = (event) => {
        this.setState({filterText: event.target.value});
    }

    clearFilter = () => {
        this.setState({filterText: ''});
    }

    render() {
        return (
            <div className='container-fluid'>
                <section id='companies'>
                    <div className='row'>

                        <div className='col-sm-4 col-md-3'>
                            <h1 className='text-left'>
                                {i18.COMPANY._bookedComaniesList}
                            </h1>
                        </div>
                        <div className='col-sm-3 col-md-2'>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    spellCheck="false"
                                    autoComplete="off"
                                    id='filterText'
                                    name='filterText'
                                    value={this.state.filterText}
                                    onKeyUp={this.onFilterChange}
                                    onChange={this.onFilterChange}
                                />
                                <div className="input-group-append">
                                    <button
                                        className="btn btn-outline-secondary"
                                        type="button"
                                        onClick={this.clearFilter}
                                    >
                                        <i className='fa fa-times' aria-hidden='true'/>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col align-self-end'>
                            <a className='float-md-right green-btn' onClick={() => this.openModal()}>{i18.COMPANY._addComapny}</a>
                        </div>
                    </div>

                    <table className='table table-striped table-aibook-no-border'>
                        <thead>
                        <tr>
                            <th>{i18.COMPANY._name}</th>
                            <th>{i18.COMPANY._bookingIntervall}</th>
                            {userHelper.hasModule('customer') ? <th className='text-center'>Vevő</th> : null}
                            {userHelper.hasModule('bank') ? <th className='text-center'>Bank</th> : null}
                            {userHelper.hasModule('supplier') ? <th className='text-center'>Szállító</th> : null}
                            {userHelper.hasModule('cashregister') ? <th className='text-center'>Pénztár</th> : null}
                            {userHelper.hasModule('mixed') ? <th className='text-center'>Vegyes</th> : null}
                            <th className='text-center'>{i18.COMPANY._operations}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.getCompanies()}
                        </tbody>
                    </table>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={() => this.closeModal()}
                        style={customStyles}
                        contentLabel='Cég hozzáadása'>
                        <h4 className='text-center'>{this.state.isNewRecord ? i18.COMPANY._addComapny : i18.COMPANY._editComapny}</h4>
                        <hr/>
                        <div>
                            <Field
                                type='text' id='company-name' name='name'
                                label='Cég neve' classLabel='control-label'
                                classInput='form-control' setValue={this.setValue.bind(this)}
                                state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        </div>
                        <br/>
                        <div className='text-center'>
                            <button className='btn btn-success btn-sm' onClick={() => this.state.isNewRecord ? this.create() : this.update()}>{i18.COMPANY._save}</button>
                            &nbsp;&nbsp;&nbsp;
                            <button className='btn btn-danger btn-sm' onClick={() => this.closeModal()}>{i18.COMPANY._close}</button>
                        </div>
                    </Modal>
                </section>
            </div>
        )
    }
}

export default Company


// WEBPACK FOOTER //
// ./src/components/company/company.js